/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventsviewlabel2Inputs */

const en_eventsviewlabel2 = /** @type {(inputs: Eventsviewlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View`)
};

const de_eventsviewlabel2 = /** @type {(inputs: Eventsviewlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansicht`)
};

/**
* | output |
* | --- |
* | "View" |
*
* @param {Eventsviewlabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventsviewlabel2 = /** @type {((inputs?: Eventsviewlabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventsviewlabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventsviewlabel2(inputs)
	return de_eventsviewlabel2(inputs)
});
export { eventsviewlabel2 as "eventsViewLabel" }